import { LuMenu, LuMic, LuSearch, LuUser } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import CartButton from "./CartButton";
import BrandLogo from "../../common/BrandLogo";
import LanguageToggle from "../../common/LanguageToggle";

interface MobileProps {
  toggleMenu: () => void;
}

/**
 * Mobile ka sticky navy header (design canvas "7 · Mobile home").
 * Logo (safed wordmark) · EN/हिं · cart · login/menu, neeche bada search box.
 * Search box par tap = /searchpage (poori screen wala search).
 */
const MobileNavbar = ({ toggleMenu }: MobileProps) => {
  const navigate = useNavigate();
  const userDetails = useSelector(
    (state: RootState) => state.Login.ContractorData
  );

  return (
    <div className="flex w-full flex-col gap-2.5 bg-ci-navy px-4 pb-3 pt-3 sm:hidden">
      <div className="flex items-center justify-between gap-2">
        <Link to="/" aria-label="Chawla Ispat — home" className="shrink-0">
          <BrandLogo
            variant="light"
            markSize={32}
            wordmarkWidth={128}
            showTagline={false}
          />
        </Link>
        <div className="flex items-center gap-3">
          <LanguageToggle />
          <CartButton iconClassName="text-white text-[24px]" />
          {userDetails ? (
            <button
              type="button"
              id="mobileSideBar"
              aria-label="Menu"
              onClick={toggleMenu}
              className="flex h-[36px] w-[36px] items-center justify-center rounded-md text-white"
            >
              <LuMenu size={24} />
            </button>
          ) : (
            <Link
              to="/signup"
              aria-label="Login"
              className="flex h-[36px] items-center gap-1 rounded-md border border-[#3d4a5c] px-2 text-[12px] font-semibold text-white"
            >
              <LuUser size={16} />
              Login
            </Link>
          )}
        </div>
      </div>

      <button
        type="button"
        aria-label="Search"
        onClick={() => navigate("/searchpage")}
        className="flex h-[46px] w-full items-center gap-2.5 rounded-md bg-white px-3 text-left"
      >
        <LuSearch size={20} className="shrink-0 text-ci-muted" />
        <span className="flex-1 truncate text-[14px] text-ci-muted">
          TMT bar, sheet, pipe, cement…
        </span>
        <LuMic size={18} className="shrink-0 text-ci-muted" />
      </button>
    </div>
  );
};

export default MobileNavbar;
